import { StackView, Box } from '@planningcenter/tapestry-react';
import React, { useState, useRef, useEffect } from 'react';

// TODO: This component could prob be genrealized to provide overflow-y scroll indication, as well, if needed.
// `top`/`bottom` // `left`/`right` → `start`/`end`
const INDICATOR_STYLES = {
    bottom: {
        background: "linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.07))",
        bottom: 0,
    },
    top: {
        background: "linear-gradient(rgba(0, 0, 0, 0.07), rgba(255, 255, 255, 0))",
        top: 0,
    },
};
// Perf: should this component be memoized?
const ScrollContainer = ({ children, ...props }) => {
    const [overflowTop, setOverflowTop] = useState(false);
    const [overflowBottom, setOverflowBottom] = useState(false);
    const containerRef = useRef(null);
    const bottomEdgeRef = useRef(null);
    const topEdgeRef = useRef(null);
    // Perf: should this be debounced?
    const handleResize = () => {
        const container = containerRef === null || containerRef === undefined ? undefined : containerRef.current;
        if (container) {
            const hasOverflowBottom = container.scrollHeight - container.clientHeight >
                container.scrollTop + 1;
            setOverflowBottom(hasOverflowBottom);
        }
    };
    useEffect(() => {
        const container = containerRef === null || containerRef === undefined ? undefined : containerRef.current;
        if (!container) {
            return () => { }; // noop
        }
        setOverflowBottom(container.scrollHeight > container.clientHeight);
        // setup intersection observers
        const options = { root: container, threshold: 1 };
        const bottomObserver = new IntersectionObserver(([{ isIntersecting }]) => setOverflowBottom(!isIntersecting), options);
        const topObserver = new IntersectionObserver(([{ isIntersecting }]) => setOverflowTop(!isIntersecting), options);
        const bottomTarget = bottomEdgeRef === null || bottomEdgeRef === undefined ? undefined : bottomEdgeRef.current;
        const topTarget = topEdgeRef === null || topEdgeRef === undefined ? undefined : topEdgeRef.current;
        if (bottomTarget) {
            bottomObserver.observe(bottomTarget);
        }
        if (topTarget) {
            topObserver.observe(topTarget);
        }
        // setup resize observer
        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(container);
        return () => {
            if (bottomTarget) {
                bottomObserver.unobserve(bottomTarget);
            }
            if (topTarget) {
                topObserver.unobserve(topTarget);
            }
            resizeObserver.unobserve(container);
        };
    }, []);
    return (React.createElement(StackView, { grow: 1, position: "relative", shrink: 1 },
        overflowTop && React.createElement(OverflowIndicator, { edge: "top" }),
        overflowBottom && React.createElement(OverflowIndicator, { edge: "bottom" }),
        React.createElement(StackView, { basis: 2, grow: 1, innerRef: containerRef, overflow: "auto", role: "region", shrink: 1, css: { overscrollBehavior: "contain" }, ...props },
            React.createElement(Box, { innerRef: topEdgeRef }),
            children,
            React.createElement(Box, { innerRef: bottomEdgeRef }))));
};
const OverflowIndicator = ({ edge }) => {
    return (React.createElement(Box, { height: 1, left: 0, pointerEvents: "none", position: "absolute", right: 0, role: "presentation", zIndex: 10, ...INDICATOR_STYLES[edge] }));
};

export { INDICATOR_STYLES, ScrollContainer };
//# sourceMappingURL=scroll_container.js.map
